export default {
	ASSETS: 'Assets',
	IMAGE_RESIZE_TOOLTIP: 'Uploaded image will be downscaled into into 2 images.'
};
